import React, { useEffect, useState } from 'react';
import { Switch, Route, useLocation, useParams } from 'react-router-dom';
import PrivateRoute from '../components/PrivateRoute/PrivateRoute';
import FirstPage from './FirstPage/FirstPage';
import AgentPanel from './AgentPanel/AgentPanel';
import ClientHome from './ClientHome/ClientHome';
import Error from '../components/Error/Error';
import GraphicBuilder from './GraphicBuilder/GraphicBuilder';
import { useDispatch, useSelector } from 'react-redux';
import { subscriptionActions, userActions } from '../actions';
import { toast } from 'react-toastify';
import ReactGA from 'react-ga';
import { hotjar } from 'react-hotjar';
import { ipapiService } from '../services';
import { useTranslation } from 'react-i18next';
import TagManager from 'react-gtm-module';
import Landing from '../containers/Landing/Landing';
import _ from 'lodash';
import './App.css';
import '../assets/fonts/vazir.css';
import 'react-toastify/dist/ReactToastify.css';
import ExportService from '../components/ExportService';

toast.configure();

const analyticsEnabled =
  process.env.NODE_ENV === 'production' &&
  typeof window !== 'undefined' &&
  window.location.protocol === 'https:' &&
  !['localhost', '127.0.0.1'].includes(window.location.hostname);

const App = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { i18n } = useTranslation();
  const user = useSelector(state => state.authentication.user);
  const [loading, setLoading] = useState(true);
  const tagManagerArgs = {
    gtmId: 'GTM-KH6B4KS',
  };

  useEffect(() => {
    if (!user) dispatch(userActions.restoreSession());

    if (analyticsEnabled) {
      ReactGA.initialize('UA-171533326-1');
      ReactGA.pageview(window.location.pathname + window.location.search);
      hotjar.initialize('1876977', 1);
      TagManager.initialize(tagManagerArgs);
    }

    // Check language
    let localLanguage = localStorage.getItem('language');
    if (!localLanguage) {
      ipapiService
        .getClientLocationInfo()
        .then(data => {
          if (data) {
            localLanguage = data.country_code === 'IR' ? 'rtl/fa-IR' : 'ltr/en-US';
            localStorage.setItem('language', localLanguage);
            setLanguage(localLanguage);
            setLoading(false);
          } else {
            localLanguage = 'rtl/fa-IR';
            localStorage.setItem('language', localLanguage);
            setLanguage(localLanguage);
            setLoading(false);
          }
        })
        .catch(() => {
          localLanguage = 'rtl/fa-IR';
          localStorage.setItem('language', localLanguage);
          setLanguage(localLanguage);
          setLoading(false);
        });
    } else {
      setLanguage(localLanguage);
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (_.get(user, 'role') === 'client') {
      dispatch(subscriptionActions.getCurrentSubscription());
    }
  }, [dispatch, user]);

  useEffect(() => {
    if (analyticsEnabled) {
      ReactGA.pageview(location.pathname + location.search);
    }
  }, [location]);

  const setLanguage = localLanguage => {
    const [dir, lang] = localLanguage.split('/');
    i18n.changeLanguage(lang.split('-')[0]); // get first past of lang for Fa, En, Tr, Ar
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
  };

  const Redirect = () => {
    let { token } = useParams();
    const link = `https://sadad.shaparak.ir/VPG/Purchase?Token=${token}`;
    useEffect(() => {
      setTimeout(() => {
        window.location = link; 
      }, 2000);
    })
    
    return(
      <div className='loaderContainer'>
        <div className="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      </div>
    )
  }

  return (
    <div className="App">
      {loading ? (
        <p>Loading...</p>
      ) : (
        <Switch>
          <PrivateRoute path="/home" component={ClientHome} />
          <PrivateRoute path="/edit/:_type/:_designId/:_tempId?" exact component={GraphicBuilder} />
          <Route path="/exportService/:_userId/:_designId/:_token" exact render={() => <ExportService />} />
          <Route path="/export/design/:_designId/:_tempId?" exact render={() => <GraphicBuilder mode="export" />} />
          <PrivateRoute path="/payment">
            <Error type="payment" />
          </PrivateRoute>
          <Route path="/ipg/:token" component={Redirect} />
          <Route path="/agents" component={AgentPanel} />
          <Route exact path="/landing" component={Landing} />
          <Route path="/" component={FirstPage} />
          <Route path="*" render={() => <Error error={'404'} />} />
        </Switch>
      )}
    </div>
  );
};

export default App;
